<ngx-ui-loader></ngx-ui-loader>
<div *ngIf="user_details">
  <app-navigation-bar *ngIf="show_navbar"> </app-navigation-bar>
  <app-notification-menu></app-notification-menu>
</div>
<div (click)="navigationService.navigationCheck()">
    <router-outlet>
    </router-outlet>
</div>